import Page_2_1 from "../../../../common/assets/images/Montronix/Video/Page_2_1.png";

import Page_3_1 from "../../../../common/assets/images/Montronix/Video/Page_3_1.png";

import Page_5_1 from "../../../../common/assets/images/Montronix/Video/Page_5_1.png";

import { Ipoint2D } from "../../../../common/interfaces";

export const videoPointsPulseNG: Ipoint2D[] = [
  {
    id: 1,
    top: "0.5rem",
    titletext:[""],
    left: "54%",
    title: "Решаемые задачи PulseNG",
    title_short: "Решаемые задачи",
    content: [""],
    text: [""],
    list: [
      {
        title: "",
        quotes: [
          "Распознавание аварий.",
          "Защита станка.",
          "Автоматическая диагностика станка.",
          "Распознавание столкновений и предельно короткое время реагирования на безопасный останов 1 мс.",
          "Минимизация последствий аварийных ситуаций.",
          "Повышение доступности оборудования за счет бесперебойной работы станка.",
          "Снижение рисков и затрат на ремонт.",
          "Повышение надежности планирования."
        ],
      },
    ],
  },
  {
    id: 2,
    top: "0.5rem",
    left: "40%",
    titletext:[""],
    title: "Алгоритм защиты от столкновений",
    title_short: "Алгоритм защиты",
    content: [Page_2_1],
    text: [
      "",
    ],
  },
  {
    id: 3,
    top: "0.5rem",
    left: "47%",
    titletext:[""],
    title: "Экономическая эффективность Montronix",
    title_short: "Экономическая эффективность",
    content: [Page_3_1],
    text: [""],
  },
  {
    id: 4,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Контроль вибрации на ШУ при обработке",
    title_short: "Контроль вибрации",
    maxWidthTable:"40vw",
    content: [""],
    text: [""],
    table: {
      tableheads: [
        { width: "33%", content: "Предел 1" },
        { width: "33%", content: "Предел 2" },
        { width: "33%", content: "Предел 3" },
      ],
      rows: [
        {
          tableText:[""],
          tableContent:[""],
          title: "",
          showhead: true,
          columns: [
            [{content:["<8 мм/с"],color:["rgb(193 208 238)"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""],boxShadow:["yes"]},
            {content:["8 мм/с – 12 мм/с"],color:["rgb(193 208 238)"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""],boxShadow:["yes"]},
            {content:[">12 мм/с"],color:["rgb(193 208 238)"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""],boxShadow:["yes"]},
            ],
            [{content:["Допустимая вибрации. Разрешена непрерывная работа."],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["Повышенное значение вибрации, допустимое время работы не более 30 сек.\nПовышенная вибрация может сократить срок службы инструмента, а ресурс шпинделя может быть резко уменьшен."],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["Работа ШУ недопустима."],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]},
            ], 
          ],
        },
      ],
    },
  },
  {
    id: 5,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Влияние вибрации на ресурс ШУ",
    title_short: "Влияние вибрации",
    content: [Page_5_1],
    text: [""],
  },
  {
    id: 6,
    top: "0.5rem",
    left: "54%",
    titletext:[""],
    title: "Технические характеристики Montronix",
    title_short: "Технические характеристики ",
    minWidthTable:"550px",
    maxWidthTable:"550px",
    content: [""],
    text: [""],
    table: {
      tableheads: [
        { width: "100%", content: "Классификация ШУ" },
      ],
      rows: [
        {
          tableText:[""],
          tableContent:[""],
          title: "3-x осевой датчик вибрации Pulse NG",
          showhead: false,
          columns: [
            [{content:["Размеры (ШxВxГ в мм)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["30 x 40 x 12"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Корпус"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Литой алюминиевый"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Вес"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["100 грамм"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Степень защиты"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP67"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Температурные ограничения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Эксплуатация 0 до 70°C, Хранение -40 до 70°C"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Относительная влажность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От 0 до 100 %"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Соединение"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["PUR кабель M8 c 4 пинами"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Длина кабеля"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["2 метра, может быть увеличен до 100 метров"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Диаметр кабеля"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["4,9 мм"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Тип датчика"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["МЭМС"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Диапазон измерения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["± 60 м/с² (± 6 g)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Линейность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["0.1 % Д.И."],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Интерфейс"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["< 2 %"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Ширина полосы пропускания"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["1.6 кГц"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Разрешение"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["0,025 м/с² @ 100 Гц"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Ударопрочность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["9810 м/с²"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Датчик температуры"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["От 0 до 70°C, абсолют погрешность 1°"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            ],   
          ],
        },
        {
          tableText:[""],
          tableContent:[""],
          title: "IBU NG",
          showhead: false,
          columns: [
            [{content:["Размеры (ШxВxГ в мм)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["120 x 42 x 120"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Корпус"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Монтируется на DIN Рейку стандарта EN 50022"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Вес"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["370 грамм"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Степень защиты"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP40"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Температурные ограничения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Эксплуатация от 0 до 50°C, хранение от -20 до 70°C"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Относительная влажность"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От 0 до 95% без конденсата"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["18-30 В DC"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Напряжение питания"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Потребляемый ток"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["300 мA max"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Время реакции"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["< 1 ms"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Входы"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["18-30 В DC, 20 мA"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Выходы"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["30 в DC, 100 мA"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["EMC (электромагнитная совместимость)"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["EN 61326-1: 2006-5"],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]},
            ],
          ],
        },
        {
          tableText:[""],
          tableContent:[""],
          title: "StrainLink250-DA",
          showhead: false,
          columns: [
            [{content:["Габаритные размеры, мм"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["17 x 69 x 26"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Материал корпуса"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["Алюминий"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Вес с магнитными креплениями, г"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["130"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Класс защиты"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["IP 67"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [
            {content:["Диапазон температур эксплуатации"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От 0°С до 70°С"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [
            {content:["Диапазон температур хранения"],color:["white"],borderRIght:["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["От –40°С до 85°С"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Напряжение питания"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["DC 5-10 В"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Выходной сигнал"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            {content:["5-33 В"],color:["white"],borderRIght:[""],borderButton:["0.25vh solid rgb(193 208 238)"],borderTop:[""]},
            ],
            [{content:["Чувствительность"],color:["white"],borderRIght: ["0.25vh solid rgb(193 208 238)"],borderButton:[""],borderTop:[""]},
            {content:["± 1,8 мВ/В @ 750 με"],color:["white"],borderRIght:[""],borderButton:[""],borderTop:[""]},
            ],
          ],
        },
      ],
    },
  }
];